import { StandardEvents } from '@shopify/events';
import { Component } from '@theme/component';

/**
 * Cercevo -- secili varyant degisince cm olcu goster gecini gunceller.
 * Horizon'un native `product-price` bileseniyle ayni section-swap desenini kullanir:
 * varyant secilince Horizon guncel section HTML'ini getirir, biz de o HTML icinden
 * kendi blogumuzu bulup icerigini degistiriyoruz.
 */
class CercevoSizeInfo extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        const { html } = detail;

        const newBlock = html.querySelector(`cercevo-size-info[data-block-id="${this.dataset.blockId}"]`);
        if (!newBlock) return;

        const { sizeContainer } = this.refs;
        const newContainer = newBlock.querySelector('[ref="sizeContainer"]');
        if (newContainer && sizeContainer) {
          sizeContainer.replaceWith(newContainer);
        }
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[cercevo-size-info] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('cercevo-size-info')) {
  customElements.define('cercevo-size-info', CercevoSizeInfo);
}
